import * as React from 'react';

import { TABLE_DENSITY } from './types/table-variants-enums';

export const TableDensityContext = React.createContext<TABLE_DENSITY | undefined>(undefined);
export const TableHeaderContext = React.createContext(false);

export function useTableDensity(): TABLE_DENSITY | undefined {
  return React.useContext(TableDensityContext);
}
